
        <div style="width:100%;heigth:100px" class="chart" #bcontainer>
        </div>
    